import { safeTruncate } from '@okam/core-lib'
import Link from 'next/link'
import Heading from '../../Heading'
import WysiwygBlock from '../../WysiwygBlock'
import type { TArticleCardProps } from './interface'
import hoverStyles from './styles'

const ArticleCard = (props: TArticleCardProps) => {
  const { bgColor = 'transparent', link, children = '', title, text, excerpt, styles } = props

  return (
    <Link href={link} passHref>
      <div css={[{ backgroundColor: `${bgColor}` }, hoverStyles, styles]} tw="rounded-4xl mx-6">
        {children && <div tw="relative aspect-square">{children}</div>}
        <div tw="flex flex-col py-4 lg:py-7">
          <Heading variant="h5" as="h3" tw="w-full mb-4">
            {title}
          </Heading>
          <WysiwygBlock variant="p" tw="font-light" content={excerpt ?? safeTruncate(text)} />
        </div>
      </div>
    </Link>
  )
}

export default ArticleCard
